import React from 'react';
import { Modal, Form, Input } from 'antd';
import { contentRsg,materialConRsg } from '@/utils/common/constants';
import BaseComponent from 'components/BaseComponent';
import 'components/Modal/modal.less';
import InputForm from 'components/Form/InputForm';
const FormItem = Form.Item;


/** 编辑、新建文件夹组件 */
@Form.create()
export class AddEditFolderComponent extends BaseComponent {

    /* 检查名称 */
    checkName = (row, value, callback) =>{       
        const name_max = 50;
        if(value.trim().length > name_max){
            callback(`${window.language['material.maxLength']}${name_max}`);
            return;
        }
        var reg = new RegExp(materialConRsg);
        if(reg.test(value.trim())){
            callback(`文件名不能包含以下任何字符: \\ / : * ? " < > |`);      
            return;     
        }

        callback();
    }

    /* 检查备注 */
    checkRemark = (row, value, callback) =>{
        const remark_max = 200;
        if(value.length > remark_max){
            callback(`${window.language['material.maxLength']}${remark_max}`);
            return;
        }
        
        callback();
    }

    render() {
        const { folderTitle: { type, title }, visible, folderData, hideAddEditFolderHandler, addEditFolderHandler, form } = this.props;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
        };
        if (!type) {
            return null;
        }
        let newData = {};
        // 编辑
        if(type === '1'){
            if(!folderData){
                return null;
            }
            if(!folderData.id){
                return null;
            }
            newData = folderData;
        }
        return (
            visible && 
            <Modal
            title={title}
            visible={visible}
            width={550}
            maskClosable={false}
            onCancel={hideAddEditFolderHandler}
            onOk={addEditFolderHandler}
            className="material-folder-model show-modal-head material-model-style"
            >
                <div className="material-all-body">
                    <Form layout="horizontal">
                        <FormItem {...formItemLayout} style={{ marginBottom:0 }}>
                            {getFieldDecorator('id', {
                                initialValue: newData.id ? newData.id : '',
                            })(
                                <Input type="hidden" />
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} className="material-form-top" label={window.language['material.columns.name']}>
                            {InputForm({
                                form,
                                type: 'input',
                                name: 'name',
                                title: window.language['material.columns.name'],
                                initialValue: newData.name ? newData.name : '',
                                style: {width: '100%'},
                                className: 'ant-input-round',
                                placeholder: window.language['common.inputContent'],
                                maxLength: '50',
                                autoComplete: 'off',
                                rules: [{
                                    required: true,
                                    message: window.language['common.inputContent']
                                }, {
                                    validator: this.checkName
                                }]
                            })}
                        </FormItem>
                        <FormItem {...formItemLayout} label={window.language['material.columns.remark']}>
                            {InputForm({
                                form,
                                type: 'textarea',
                                name: 'remark',
                                title: window.language['material.columns.remark'],
                                initialValue: newData.remark ? newData.remark : '',
                                style: { width: 393, height: 100, resize: "none", borderRadius: '4px' },
                                className: 'ant-input-round',
                                placeholder: window.language['common.inputRemarkContent'].replace("{1}", 200),
                                maxLength: '200',
                                autoComplete: 'off',
                                rules: [{
                                    validator: this.checkRemark
                                }]
                            })}
                        </FormItem>
                    </Form>
                </div>
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/addEditFolderComponent.js